module.exports = __webpack_public_path__ + "static/media/YM59_2.6b367740.jpg";